import { render, staticRenderFns } from "./candidateForm.vue?vue&type=template&id=6d7acafa&scoped=true&"
import script from "./candidateForm.vue?vue&type=script&lang=js&"
export * from "./candidateForm.vue?vue&type=script&lang=js&"
import style0 from "./candidateForm.vue?vue&type=style&index=0&id=6d7acafa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7acafa",
  null
  
)

export default component.exports